module.exports = __webpack_public_path__ + "img/ico_popup_close.0d79d448.svg";